﻿﻿export interface IMedicineUseHistory {
    name: string;
    dose: string;
    frequency: string;
}
